<div class="finance-list-page">
    <app-page-shell>
        <p-toast position="top-center"></p-toast>
        <p-progressBar mode="indeterminate" *ngIf="isLoading"></p-progressBar>

        <app-page-hero [eyebrow]="t('pages.generatedReceipts.hero.eyebrow')" [title]="t('pages.generatedReceipts.hero.title')"
            [subtitle]="t('pages.generatedReceipts.hero.subtitle')">
            <div actions>
                <p-button *ngIf="canCreateReceipt && !isConsolidatedReadOnly" [label]="t('pages.generatedReceipts.actions.createReceipt')" icon="fa-solid fa-wallet"
                    severity="info" (click)="createReceipt()"></p-button>
                <p-button *ngIf="canApplyReceipt && !isConsolidatedReadOnly" [label]="t('pages.generatedReceipts.actions.applyReceipt')" icon="fa-solid fa-sliders"
                    severity="warn" (click)="applyReceiptOnInvoice()" [disabled]="!selectedReceipts.length"></p-button>
                <p-button *ngIf="canRegisterPayment && !isConsolidatedReadOnly" [label]="t('pages.generatedReceipts.actions.registerPayment')" icon="fa-solid fa-trowel-bricks"
                    severity="help" (click)="generatePaymentFromReceipts()" [disabled]="!selectedReceipts.length"></p-button>
            </div>
        </app-page-hero>

        <app-page-metric-strip [metrics]="metrics"></app-page-metric-strip>

        <app-page-search-panel [title]="t('pages.generatedReceipts.search.title')" [activeFilters]="activeFilterCount"
            [resultText]="resultText" [collapsed]="true" (search)="applyFilters()" (clear)="clearFilters()">
            <div class="finance-search-grid">
                <app-company-scope-selector (scopeChange)="onScopeChange($event)"></app-company-scope-selector>

                <div class="field">
                    <p-inputGroup>
                        <p-inputGroupAddon><i class="pi pi-users"></i></p-inputGroupAddon>
                        <p-iftalabel>
                            <p-multiSelect inputId="client" [options]="clients" [(ngModel)]="selectedClients"
                                optionLabel="name" display="chip" [showClear]="true" styleClass="w-full"></p-multiSelect>
                            <label for="client">{{ t('pages.generatedReceipts.search.customers') }}</label>
                        </p-iftalabel>
                    </p-inputGroup>
                </div>

                <div class="field">
                    <p-inputGroup>
                        <p-inputGroupAddon><i class="pi pi-calendar"></i></p-inputGroupAddon>
                        <p-iftalabel>
                            <p-datePicker inputId="dateRange" [(ngModel)]="dateRange" selectionMode="range"
                                [readonlyInput]="true" dateFormat="yy-mm-dd" appendTo="body"
                                styleClass="w-full"></p-datePicker>
                            <label for="dateRange">{{ t('pages.generatedReceipts.search.receiptDateRange') }}</label>
                        </p-iftalabel>
                    </p-inputGroup>
                </div>

                <div class="field">
                    <p-inputGroup>
                        <p-inputGroupAddon><i class="pi pi-tag"></i></p-inputGroupAddon>
                        <p-iftalabel>
                            <p-multiSelect inputId="status" [options]="statuses" [(ngModel)]="selectedStatuses"
                                display="chip" [showClear]="true" styleClass="w-full"></p-multiSelect>
                            <label for="status">{{ t('pages.generatedReceipts.search.status') }}</label>
                        </p-iftalabel>
                    </p-inputGroup>
                </div>

                <div class="field">
                    <p-inputGroup>
                        <p-inputGroupAddon><i class="pi pi-receipt"></i></p-inputGroupAddon>
                        <p-iftalabel>
                            <input id="receiptNumber" type="text" pInputText [(ngModel)]="receiptNumberFilter" />
                            <label for="receiptNumber">{{ t('pages.generatedReceipts.search.receiptNumber') }}</label>
                        </p-iftalabel>
                    </p-inputGroup>
                </div>

                <div class="field">
                    <p-inputGroup>
                        <p-inputGroupAddon><i class="pi pi-money-bill"></i></p-inputGroupAddon>
                        <p-iftalabel>
                            <input id="paymentTxnNumber" type="text" pInputText
                                [(ngModel)]="paymentTransactionNumberFilter" />
                            <label for="paymentTxnNumber">{{ t('pages.generatedReceipts.search.paymentTransactionNumber') }}</label>
                        </p-iftalabel>
                    </p-inputGroup>
                </div>
            </div>
        </app-page-search-panel>

        <app-page-data-panel [title]="t('pages.generatedReceipts.dataPanel.title')"
            [subtitle]="t('pages.generatedReceipts.dataPanel.subtitle')"
            [resultText]="resultText">
            <div actions>
                <p-button [label]="t('pages.generatedReceipts.actions.export')" icon="pi pi-file-excel" severity="secondary" [outlined]="true"
                    [loading]="isLoading" (click)="exportToExcel()"></p-button>
            </div>

            <div class="bulk-action-bar" *ngIf="selectedReceipts.length && !isConsolidatedReadOnly">
                <div>
                    <strong>{{ selectedReceipts.length }}</strong> {{ t('pages.generatedReceipts.bulk.selected') }},
                    <strong>{{ formatMoney(getSelectedTotal()) }}</strong>
                </div>
                <div class="bulk-actions">
                    <p-button *ngIf="canApplyReceipt" [label]="t('pages.generatedReceipts.actions.applyReceipt')" icon="fa-solid fa-sliders"
                        severity="warn" (click)="applyReceiptOnInvoice()" [disabled]="!selectedReceipts.length"></p-button>
                    <p-button *ngIf="canRegisterPayment" [label]="t('pages.generatedReceipts.actions.registerPayment')" icon="fa-solid fa-trowel-bricks"
                        severity="help" (click)="generatePaymentFromReceipts()" [disabled]="!selectedReceipts.length"></p-button>
                </div>
            </div>

            <app-accounting-directory-controls documentType="RECEIPT" [filters]="directoryFilters"
                [searchText]="searchText" [selectedStatuses]="selectedDocumentStatuses" [pendingStatuses]="pendingStatuses" (searchTextChange)="onDirectorySearch($event)"
                (modeChange)="onDirectoryModeChange($event)" (pending)="showPendingStatuses()"
                (all)="showAllStatuses()"></app-accounting-directory-controls>
            <p-table *ngIf="directoryMode === 'LIST'" class="finance-table" [value]="allReceipts" dataKey="receiptId" [paginator]="true"
                [rows]="rows" [first]="first" [showCurrentPageReport]="true" [totalRecords]="totalRecords"
                [lazy]="true" [currentPageReportTemplate]="currentPageReportTemplate"
                (onLazyLoad)="loadData($event)" [rowsPerPageOptions]="[20, 50, 100]"
                [(selection)]="selectedReceipts" [tableStyle]="{ 'min-width': '0' }">
                <ng-template pTemplate="header">
                    <tr>
                        <th *ngIf="!isConsolidatedReadOnly" style="width: 3.5rem"><p-tableHeaderCheckbox></p-tableHeaderCheckbox></th>
                        <th>{{ t('pages.generatedReceipts.table.receipt') }}</th>
                        <th>{{ t('pages.generatedReceipts.table.customer') }}</th>
                        <th>{{ t('pages.generatedReceipts.table.appliedUnappliedAmounts') }}</th>
                        <th>{{ t('pages.generatedReceipts.table.allocationStatus') }}</th>
                        <th>{{ t('pages.generatedReceipts.table.paymentDetails') }}</th>
                        <th>{{ t('pages.generatedReceipts.table.actions') }}</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-receipt>
                    <tr>
                        <td *ngIf="!isConsolidatedReadOnly" [attr.data-label]="t('pages.generatedReceipts.table.select')"><p-tableCheckbox [value]="receipt"></p-tableCheckbox></td>
                        <td [attr.data-label]="t('pages.generatedReceipts.table.receipt')">
                            <div class="stack-cell">
                                <span class="cell-title">{{ receipt.receiptNumber || t('pages.generatedReceipts.table.noReceiptNumber') }}</span>
                                <div class="cell-meta">
                                    <span class="code-pill">{{ t('pages.generatedReceipts.table.id') }} {{ receipt.receiptId || '-' }}</span>
                                    <span>{{ receipt.receiptDate | date:'yyyy-MM-dd' }}</span>
                                </div>
                            </div>
                        </td>
                        <td [attr.data-label]="t('pages.generatedReceipts.table.customer')">
                            <div class="stack-cell">
                                <span class="cell-title">{{ crmPartyContext.displayName(receipt) }}</span>
                                <div class="cell-meta">{{ t('pages.generatedReceipts.table.contact') }}: {{ crmPartyContext.contactDisplayName(receipt) }}</div>
                            </div>
                        </td>
                        <td [attr.data-label]="t('pages.generatedReceipts.table.appliedUnappliedAmounts')">
                            <div class="amount-block">
                                <span class="amount-primary">{{ receipt.amount | currency:receipt.country?.currencyCode:(receipt.country?.currencyCode || 'SAR') + ' ' : '1.4-4' }}</span>
                                <span class="amount-secondary">{{ t('pages.generatedReceipts.table.applied') }} {{ getAppliedAmount(receipt) | currency:receipt.country?.currencyCode:(receipt.country?.currencyCode || 'SAR') + ' ' : '1.4-4' }}</span>
                                <span class="amount-secondary">{{ t('pages.generatedReceipts.table.unapplied') }} {{ getUnAppliedAmount(receipt) | currency:receipt.country?.currencyCode:(receipt.country?.currencyCode || 'SAR') + ' ' : '1.4-4' }}</span>
                            </div>
                        </td>
                        <td [attr.data-label]="t('pages.generatedReceipts.table.allocationStatus')">
                            <div class="status-stack">
                                <p-tag *ngIf="receipt.documentStatus" [value]="receipt.documentStatus" [severity]="statusSeverity(receipt.documentStatus)"></p-tag>
                                <p-tag [severity]="statusSeverity(receipt.status)" [value]="statusLabel(receipt.status)"></p-tag>
                                <span class="muted-pill">{{ t('pages.generatedReceipts.table.invoiceCount', { count: receipt.invoices?.length || 0 }) }}</span>
                            </div>
                        </td>
                        <td [attr.data-label]="t('pages.generatedReceipts.table.paymentDetails')">
                            <div class="stack-cell">
                                <span class="cell-title">{{ receipt.paymentTransactionNumber || t('pages.generatedReceipts.table.noPaymentTransaction') }}</span>
                                <div class="cell-meta vertical">
                                    <span>{{ receipt.isDigitalPayment ? t('pages.generatedReceipts.table.digitalPayment') : t('pages.generatedReceipts.table.manualPayment') }}</span>
                                    <span>{{ t('pages.generatedReceipts.table.created') }} {{ receipt.createdAt | date:'yyyy-MM-dd' }}</span>
                                </div>
                            </div>
                        </td>
                        <td [attr.data-label]="t('pages.generatedReceipts.table.actions')">
                            <div class="row-actions">
                                <p-button *ngIf="canEditDraft(receipt)" icon="pi pi-pencil" [rounded]="true" [text]="true" pTooltip="Edit draft" (click)="editDraft(receipt)"></p-button>
                                <p-button icon="pi pi-eye" [rounded]="true" [text]="true" [pTooltip]="t('pages.generatedReceipts.tooltips.viewReceipt', 'View receipt')"
                                    (click)="viewReceipt(receipt)"></p-button>
                                <p-button icon="pi pi-list" [rounded]="true" [text]="true" [pTooltip]="t('pages.generatedReceipts.tooltips.previewInvoices', 'Preview invoices')"
                                    (click)="openPreview(receipt)"></p-button>
                                <app-finance-pdf-view-button kind="receipt" [documentId]="receipt.receiptId" [documentReference]="receipt.receiptNumber" [postingStatus]="receipt.postingStatus" [iconOnly]="true" [disabled]="documentActions.isPending(receipt.receiptId)"></app-finance-pdf-view-button>
                                <p-button [icon]="receipt.postingStatus === 'POSTED' ? 'pi pi-download' : 'pi pi-print'" [rounded]="true" [text]="true" severity="info" [loading]="documentActions.isPending(receipt.receiptId)"
                                    [pTooltip]="receipt.postingStatus === 'POSTED' ? t('pages.generatedReceipts.tooltips.downloadReceipt', 'Download Receipt') : 'Print / reprint draft from latest saved changes'" (click)="downloadReceipt(receipt)"></p-button>
                            </div>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="7">
                            <div class="empty-state">
                                <i class="pi pi-inbox"></i>
                                <strong>{{ t('pages.generatedReceipts.empty.title') }}</strong>
                                <span>{{ t('pages.generatedReceipts.empty.subtitle') }}</span>
                            </div>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </app-page-data-panel>
    </app-page-shell>

    <p-drawer [(visible)]="isPreviewVisible" position="right" styleClass="finance-preview-drawer">
        <ng-template pTemplate="header">
            <div class="stack-cell">
                <strong>{{ previewReceipt?.receiptNumber || t('pages.generatedReceipts.preview.linkedInvoices') }}</strong>
                <span class="cell-meta">{{ t('pages.generatedReceipts.preview.invoiceCount', { count: previewReceipt?.invoices?.length || 0 }) }}</span>
            </div>
        </ng-template>
        <div class="preview-list" *ngIf="previewReceipt?.invoices?.length; else noReceiptInvoices">
            <div class="preview-line" *ngFor="let invoice of previewReceipt?.invoices">
                <div class="preview-line-header">
                    <div>
                        <div class="preview-line-title">{{ invoice.invoiceNumber || t('pages.generatedReceipts.preview.invoice') }}</div>
                        <div class="cell-meta">{{ invoice.invoiceCreationDate | date:'yyyy-MM-dd' }}</div>
                    </div>
                    <div class="preview-line-amount">{{ formatMoney(invoice.totalAmount, invoice.country.currencyCode) }}</div>
                </div>
            </div>
        </div>
        <ng-template #noReceiptInvoices>
            <div class="preview-empty">{{ t('pages.generatedReceipts.preview.noLinkedInvoices') }}</div>
        </ng-template>
    </p-drawer>
</div>
